import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './Theme.less';

const ThemeDefault = (props) => {
  const {
    children, className, theme, ...p
  } = props; // eslint-disable-line no-unused-vars
  return (
    <div className={cx(styles.theme, className)} {...p}>
      {children}
    </div>
  );
};

ThemeDefault.defaultProps = {
  children: [],
  className: null,
  theme: null,
};

ThemeDefault.propTypes = {
  children: PropTypes.shape(),
  className: PropTypes.func,
  theme: PropTypes.func,
};
export default ThemeDefault;
